const TextInput = ({ id, type, text, placeholder, autoComplete, value, onChange }) => {
  return (
    <div>
      <label htmlFor={id} className="text-gray-800">{text}</label>
      <input
        type={type}
        id={id}
        name={id}
        placeholder={placeholder}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
      />
    </div>
  );
};

export default TextInput;
